export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  clientId: process.env.REACT_APP_AUTH_CLIENTID,
  callbackUrl: process.env.REACT_APP_AUTH_CALLBACKURL,
  audience: process.env.REACT_APP_AUTH_AUDIENCE,
  defaultDashboardKey: process.env.REACT_APP_DEFAULT_DASHBOARD_KEY,
}

export const LOGOUT_RETURN_URL = process.env.REACT_APP_LOGOUT_RETURN_URL;
export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT;
export const SOCKET_ENDPOINT = process.env.REACT_APP_SOCKET_ENDPOINT;
export const SHIPPING_LABELS_DOWNLOAD_URL = process.env.REACT_APP_SHIPPING_LABELS_DOWNLOAD_URL;
export const INVOICES_DOWNLOAD_URL = process.env.REACT_APP_INVOICES_DOWNLOAD_URL;
export const US_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_US_STRIPE_PUBLISHABLE_KEY;
export const EU_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_EU_STRIPE_PUBLISHABLE_KEY;
export const CH_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_CH_STRIPE_PUBLISHABLE_KEY;
export const CA_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_CA_STRIPE_PUBLISHABLE_KEY;
export const UK_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_UK_STRIPE_PUBLISHABLE_KEY;
export const SG_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_SG_STRIPE_PUBLISHABLE_KEY;

export const JURISDICTIONS = {
  EU: "alpine-water-gmbh",
  USA: "alpine-water-usa-llc",
  SWITZERLAND: "alpine-water-schweiz-gmbh",
  CANADA: "hallstein-water-canada-inc",
  UK: "alpine-water-uk",
  SG: "hallstein-water-sg"
}

export function getStripePublishableKey(shopId) {
  switch (shopId) {
    case JURISDICTIONS.EU:
      return EU_STRIPE_PUBLISHABLE_KEY;

    case JURISDICTIONS.USA:
      return US_STRIPE_PUBLISHABLE_KEY;

    case JURISDICTIONS.SWITZERLAND:
      return CH_STRIPE_PUBLISHABLE_KEY;

    case JURISDICTIONS.CANADA:
      return CA_STRIPE_PUBLISHABLE_KEY;

    case JURISDICTIONS.UK:
      return UK_STRIPE_PUBLISHABLE_KEY;

    case JURISDICTIONS.SG:
      return SG_STRIPE_PUBLISHABLE_KEY;

    default:
      throw new Error(`No Stripe key for jurisdiction ${shopId}`);
  }
}

export function getShopName(shopId) {
  switch (shopId) {
    case JURISDICTIONS.EU:
      return "Europe";

    case JURISDICTIONS.USA:
      return "USA";

    case JURISDICTIONS.SWITZERLAND:
      return "Switzerland";

    case JURISDICTIONS.CANADA:
      return "Canada";

    case JURISDICTIONS.UK:
      return "United Kingdom";

    case JURISDICTIONS.SG:
      return "Singapore";

    default:
      throw new Error(`No key for jurisdiction ${shopId}`);
  }
}

export function getShopCurrency(shopId) {
  switch (shopId) {
    case JURISDICTIONS.EU:
      return "EUR";

    case JURISDICTIONS.USA:
      return "USD";

    case JURISDICTIONS.SWITZERLAND:
      return "EUR"; // We use euros there too

    case JURISDICTIONS.CANADA:
      return "CAD";

    case JURISDICTIONS.UK:
      return "GBP";

    case JURISDICTIONS.SG:
      return "SGD";

    default:
      throw new Error(`No key for jurisdiction ${shopId}`);
  }
}
